import React, { useEffect, useState } from "react"
import showpasswordlogo from "../../../assets/images/lystfacelogos/showpassword.svg"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap"
import Select from "react-select"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import withRouter from "../../Common/withRouter"

import { resetForgotPswdResponseMsg, userForgetPassword } from "../../../store/actions"
import form_input_patterns from "../../../constants/form_input_patterns"
import SmallLoader from "../../Common/SmallLoader"
import form_messages from "../../../constants/form_messages"
import { CustomToast, ToastContainer } from "../Common/CustomToast"

//Import Breadcrumb

const ForgotPassForm = props => {
  const dispatch = useDispatch()

  const ForgetPasswordState = state => state.ForgetPassword
  const ForgotPasswordProperties = createSelector(
    ForgetPasswordState,
    ForgotPassword => ({
      loading: ForgotPassword.loading,
      forgotPasswordErrorMessage: ForgotPassword.forgotPasswordErrorMessage,
      forgotPasswordError: ForgotPassword.forgotPasswordError,
      user: ForgotPassword.user,
      linkSend: ForgotPassword.linkSend,
    })
  )
  const {
    user,
    linkSend,
    loading,
    forgotPasswordErrorMessage,
    forgotPasswordError,
  } = useSelector(ForgotPasswordProperties)

  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .test("email", form_messages.Signup.email.Invalid, function (value) {
          let emailRegex
          if (process.env.REACT_APP_NODE !== "prod") {
            emailRegex = form_input_patterns.TESTING_EMAIL

          }
          else {
            emailRegex = form_input_patterns.EMAIL

          }
          return emailRegex.test(value)
        })
        .max(255)
        .required(form_messages.Signup.businessemail.Required),
    }),
    onSubmit: values => {
      const ForgotPasswordData = {
        email: values.email,
      }
      dispatch(userForgetPassword(ForgotPasswordData, props.router.navigate))
    },
  })


  const onSubmitForm = (e) => {
    e.preventDefault()
    validationType.handleSubmit()
    return false
  }



  return (
    <React.Fragment>
      <div className="auth-form-container">
        <Card>
          <CardBody>
            <Form
              onSubmit={(e) => onSubmitForm(e)}
              className="custom-validation"
            >
              <div className="title">
                Forgot password
              </div>
              <div className="mail-id-text">
                Please enter your registered e-mail id.
              </div>
              <div className="form-fields-container">
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Business email<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="email"
                    className={`form-input ${validationType.touched.email && validationType.errors.email
                      ? `border-danger`
                      : ``
                      }`}
                    type="text"
                    formNoValidate={true}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.email?.trimStart() || ""}
                  />
                  {validationType.touched.email && validationType.errors.email ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.email}
                    </FormFeedback>
                  ) : null}
                </div>
              </div>
              <button
                className="background-button"
                disabled={loading}
              > {loading ? <SmallLoader /> : "Reset password"}</button>

            </Form>
          </CardBody>
        </Card>
        {/* <ToastContainer /> */}
      </div>
    </React.Fragment>
  )
}

export default withRouter(ForgotPassForm)
ForgotPassForm.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}
